// The structure of the keys is not the same as the others because they were imported from a yml file.
// Apparently this was a legacy project using a different structure.

export default {
  next: 'Verder',
  back: 'Terug',
  kcal: 'kcal',
  gram: 'g',
  or: 'of',
  and: 'en',
  andIs: 'en is',
  orWeight: 'en heeft',
  weightKg: 'Geen zorgen, als je het niet precies weet, is een schatting ook prima.',
  year: 'jaar',
  years: 'jaar',
  month: 'maand',
  months: 'maanden',
  'indefiniteArticle.male': 'een',
  'indefiniteArticle.female': 'een',
  'definiteArticle.male': 'de',
  'definiteArticle.female': 'de',
  'pronoun.male': 'hij',
  'pronoun.female': 'zij',
  'possessivePronoun.male': 'zijn',
  'possessivePronoun.female': 'haar',
  'genderSuffix.male': '',
  'genderSuffix.female': '',
  'month.1': 'januari',
  'month.2': 'februari',
  'month.3': 'maart',
  'month.4': 'april',
  'month.5': 'mei',
  'month.6': 'juni',
  'month.7': 'juli',
  'month.8': 'augustus',
  'month.9': 'september',
  'month.10': 'oktober',
  'month.11': 'november',
  'month.12': 'december',
  'petName.message':
    'Vertel ons gerust meer over je huisdier, zodat we je het product kunnen aanbevelen dat het beste bij jullie past.',

  'input.petName.placeholder': 'Naam invoeren',
  'input.petName.hint.min': 'Min. twee letters',

  'input.dateOfBirth.description':
    'Geen zorgen, als je het niet precies weet, is een schatting ook prima.',

  'input.weightKg.placeholder': 'Gewicht in kg',

  'input.allergies.description':
    '<b>Waarom is dit belangrijk?</b> Zo weten we welke voedingsmiddelen we in onze aanbeveling moeten vermijden.',
  'input.allergies.opt.beefordairy': 'Rundvlees of zuivelproducten',
  'input.allergies.opt.fish': 'Vis',
  'input.allergies.opt.grains': 'Granen',
  'input.allergies.opt.duck': 'Eend',
  'input.allergies.opt.chickenoreggs': 'Kip of ei',
  'input.allergies.opt.lamb': 'Lam',
  'input.allergies.opt.potato': 'Aardappelen',
  'input.allergies.opt.horse': 'Paard',
  'input.allergies.opt.goat': 'Geit',
  'input.allergies.opt.turkey': 'Kalkoen',
  'input.allergies.opt.none': 'Geen bekend',

  'input.otherAllergies.opt.kangaroo': 'Kangoeroe',
  'input.otherAllergies.opt.deer': 'Hert',
  'input.otherAllergies.opt.buffalo': 'Buffel',
  'input.otherAllergies.opt.wildBoar': 'Wild zwijn',
  'input.otherAllergies.opt.insects': 'Insecten',
  'input.otherAllergies.opt.sweetpotato': 'Zoete aardappelen',
  'input.otherAllergies.opt.peas': 'Erwten',
  'input.otherAllergies.opt.pumpkin': 'Pompoen',
  'input.otherAllergies.opt.carrot': 'Wortelen',
  'input.otherAllergies.opt.parsnip': 'Pastinaak',
  'input.otherAllergies.opt.zuchini': 'Courgette',
  'input.otherAllergies.opt.broccoli': 'Broccoli',
  'input.otherAllergies.opt.amaranth': 'Amarant',
  'input.otherAllergies.opt.quinoa': 'Quinoa',
  'input.otherAllergies.opt.buckwheat': 'Boekweit',
  'input.otherAllergies.opt.other': 'De allergie wordt hier niet weergegeven',
  'input.otherAllergies.placeholder': 'Anders, hier invoeren',

  'input.foodTypePreference.description':
    'Je kunt meerdere opties selecteren. Op basis van je keuze stellen we een passend proefpakket voor {petName} samen. ',
  'input.foodTypePreferences.opt.barf': 'BARF',
  'input.foodTypePreferences.opt.wetfood': 'Natvoer',
  'input.foodTypePreferences.opt.dryfood': 'Droogvoer',
  'input.foodTypePreferences.opt.filetmenu': 'met filetstukjes',
  'input.foodTypePreferences.opt.mousse': 'luchtige mousseconsistentie',
  'input.foodTypePreferences.opt.puremeat': 'veel vlees',
  'input.foodTypePreferences.opt.saucenmenu': 'menu met veel saus',
  'input.foodTypePreferences.opt.none': 'Twijfel nog',

  'input.foodTypePreferences.message':
    'Je kunt meerdere opties selecteren. Als je twijfelt of geen voorkeuren hebt, selecteer dan alle opties.',
  'input.foodTypePreferences.description':
    '<b>Waarom is dit belangrijk?</b> Zo kunnen we bij de voerkeuze rekening houden met bepaalde voorkeuren.',

  'input.catType.opt.indoor': 'Een echte binnenkat of binnenkater',
  'input.catType.opt.outdoor': 'Buitenkat',
  'input.isSpecificDisease.title': '',
  'input.isMeatIntolerance.title': '',
  'input.breed.description':
    '<b>Waarom is dit belangrijk?</b> Sommige rassen hebben speciale behoeften waarmee we bij onze voeraanbeveling rekening willen houden.',
  'input.breed.placeholder': 'Hier ras invoeren',
  'checkbox:breed': 'Weet ik niet',

  'input.illnesses.description':
    '<b>Waarom is dit belangrijk?</b> Zo kunnen we het passende voer voor {petText} vinden.',
  'input.illnesses.opt.picky eater': 'Kieskeurig eetgedrag',
  'input.illnesses.opt.digestion': 'Spijsvertering',
  'input.illnesses.opt.skin-fur': 'Huid & vacht',
  'input.illnesses.opt.low purine': 'Purinearm',
  'input.illnesses.opt.diabetes': 'Diabetes',
  'input.illnesses.opt.osteoarthritis': 'Gewrichten',
  'input.illnesses.opt.storage mites': 'Voedermijten',
  'input.illnesses.opt.struvite stones': 'Struvietstenen',
  'input.illnesses.opt.renal or liver failure': 'Nieren of lever',
  'input.illnesses.opt.gastro intestinal issues or pancreatitis': 'Maag-darm / pancreatitis',
  'input.illnesses.opt.other': 'Niet vermeld',
  'input.illnesses.opt.none': 'Geen bekend',

  'input.weightGoal.opt.lose': 'Ondergewicht',
  'input.weightGoal.opt.maintain': 'Ideaal gewicht',
  'input.weightGoal.opt.gain': 'Overgewicht',

  'input.name.description':
    'Zodat we je een persoonlijke voedingsaanbeveling voor {petName} kunnen sturen, laat ons weten hoe je heet.',
  'input.ownerFirstName.placeholder': 'Voornaam',
  'input.ownerFirstName.label': 'Je voornaam',
  'input.ownerFirstName.hint.min': 'Dat lijkt een beetje kort.',
  'input.ownerLastName.label': 'Je achternaam',
  'input.ownerLastName.placeholder': 'Achternaam',
  'input.ownerLastName.hint.min': 'Dat lijkt een beetje kort.',

  'input.ownerEmail.placeholder': 'jouw@email.nl',
  'input.ownerEmail.description':
    'Yay! We hebben het juiste voor {petText} gevonden! Nu missen we alleen nog je e-mail om je je resultaten te sturen.',
  'input.ownerEmail.hint.email': 'Geef een geldig e-mailadres op',
  'input.neutered.opt.true': 'Ja',
  'input.neutered.opt.false': 'Nee',
  'input.gender.opt.female': 'Vrouwtje',
  'input.gender.opt.male': 'Mannetje',

  'evaluation.title': 'Persoonlijk voerplan voor <strong>{petName}</strong>',
  'evaluation.loading': 'Laden...',
  'evaluation.description':
    '{petName} heeft gemiddeld ca. {foodTypes} van de geselecteerde Pets Deli soorten nodig. Deze voerbehoefte volgt uit de energie- en voedingswaarden van de geselecteerde Pets Deli soorten.',
  'evaluation.table.dailyKcal': 'Caloriebehoefte van {petName}',
  'evaluation.table.factor': 'Factor',
  'evaluation.table.caloryRequirements': 'Calorieën',
  'evaluation.table.RER': 'Energieverbruik in rust',
  'evaluation.table.RER.description':
    'Hiermee wordt de basisstofwisseling van je viervoeter beschreven, d.w.z. zoveel energie verbrandt je dier ongeveer in rust of bij weinig tot geen activiteit.',
  'evaluation.table.neutered': 'Sterilisatie',
  'evaluation.table.neutered.description':
    'Bij gesteriliseerde dieren daalt de hormoonactiviteit een beetje en daardoor vertraagt ook de stofwisseling. Hierdoor verbruikt je viervoeter iets minder energie, oftewel voeding, dan een niet-gesteriliseerd dier.',
  'evaluation.table.temper': 'Temperament',
  'evaluation.table.temper.description':
    'Het temperament weerspiegelt in belangrijke mate het activiteitsniveau van een huisdier. Afhankelijk van hoeveel je pluizige viervoeter beweegt, is er meer of minder energie nodig om de lichaamsfuncties in stand te houden.',
  'evaluation.foodType.barf': 'BARF',
  'evaluation.foodType.wetfood': 'Natvoer',
  'evaluation.foodType.dryfood': 'Droogvoer',
  'evaluation.foodType.none': 'Twijfel nog',
  'evaluation.suggestionsTitle': 'En we raden bovendien aan:',
  'evaluation.suggestionsSubtitle':
    'Voeg gewoon de voor jou passende producten toe aan&nbsp;je&nbsp;winkelwagen',
  'evaluation.button.trySelection': 'Selectie proberen!',
  'evaluation.otherPopularProducts.title': 'Andere populaire producten',
  'suggestions.title': 'Onze aanbeveling voor {petName}:',
  'suggestion.title': 'Onze aanbeveling',
  'product.more': 'Meer weten',
  'product.toTry': 'Om kennis te maken',
  'product.deliveryTime': '1-2 dagen',
  'product.add': 'In de winkelwagen',
  'results.temper.lazy': 'minder actief',
  'results.temper.quiet': 'rustig',
  'results.temper.average': 'gemiddeld',
  'results.temper.active': 'actief',
  'results.temper.restless': 'zeer actief',
  'results.neutered.female': 'gecastreerde',
  'results.neutered.male': 'gecastreerde',
  'results.description':
    '{petName} is {indefiniteArticle} {temper}{genderSuffix}{neutered} {breed}. Voor een evenwichtige voeding heeft {pronoun} ca. {kcal} kCal per dag nodig om {possesivePronoun} gewicht op peil te houden. Dat komt overeen met ca. {foodTypes}.',
  'results.table.title': 'Behoefte van {possessivePetName}',
  'results.table.subtitle': 'op basis van de opgegeven informatie',
  'results.next': 'Naar je producten',

  'wizard.title.petName': 'Hoe heet je viervoeter?',
  'wizard.title.breed': 'Tot welk ras behoort {petName}?',
  'wizard.title.dateOfBirth': 'Wanneer is {petName} geboren?',
  'wizard.title.weightKg': 'Hoeveel weegt {petName}?',
  'wizard.title.allergies': 'Is er een voedselallergie bekend? Zo ja, welke:',
  'wizard.title.illnesses': 'Waar heeft {petName} een probleem mee?',
  'wizard.title.foodTypePreferences': 'Wat moet {petName} krijgen?',
  'wizard.title.ownerEmail': 'Wat is je e-mailadres?',
  'wizard.title.neutered': 'Is {petName} gecastreerd?',
  'wizard.title.gender': 'Welk geslacht heeft {petName}?',

  'foodaid:page-title': 'Voeradviseur',

  'foodaid:questions:policy-1': 'Door je gegevens te verzenden ga je akkoord met onze',
  'foodaid:questions:policy-2': 'algemene voorwaarden',
  'foodaid:questions:policy-3': 'privacybeleid',
  'foodaid:questions:policy-4':
    'en ga je ermee akkoord dat Pets Deli je af en toe wijst op passende producten voor je viervoeter.',

  'foodaid:evaluation:item-added-to-cart': '✓ TOEGEVOEGD!',
  'foodaid:evaluation:sub-title': 'Leg gewoon de voor jou passende producten in de winkelwagen!',
  'foodaid:evaluation:results':
    '{count, number} {count, plural, one {resultaat} other {resultaten}}',
  'foodaid:evaluation:our-categories': 'Onze categorie',

  'foodaid:results:extended-title': 'Passende producten voor {petName}',
  'foodaid:results:title': 'Passende producten',
  'foodaid:lazy-input:pet-name-input-dog': 'Naam van je hond',
  'foodaid:lazy-input:pet-name-input-cat': 'Naam van je poes',
  'foodaid:lazy-input:create-nutrition-plan': 'Starten',
  'foodaid:support:title': 'Bij ons krijgen bijzondere dieren een persoonlijk advies!',
  'foodaid:support:description':
    'Het lijkt erop dat {petName} bepaalde behoeften heeft. Onze experts staan voor jullie klaar! Neem contact met ons op via:',
  'foodaid:support:schedule-appointment':
    'Onze adviseurs nemen contact met je op / Onze adviseurs bellen je op de afgesproken tijd',
  'foodaid:support:button:phone': 'Telefoon',
  'foodaid:support:button:email': 'E-mail',
  'foodaid:support:button:whatsapp': 'WhatsApp',
  'foodaid:support:button:home': 'Home',

  'foodaid:loading-screen:loading': 'Laden...',
  'foodaid:loading-screen:title': 'We zijn zo klaar met het perfecte voer voor {petName}!',
  'foodaid:loading-screen:description-1':
    'Terwijl je wacht: wist je dat sommige honden sneller zijn dan cheetahs?',
  'foodaid:loading-screen:description-2':
    'Het reukvermogen van een hond is minstens 40x beter dan dat van ons.',
  'foodaid:questions:case-data:petName': 'Naam',
  'foodaid:questions:case-data:allergies': 'Voedselallergie',
  'foodaid:questions:case-data:otherAllergies': 'Andere allergieën',
  'foodaid:questions:case-data:breed': 'Ras',
  'foodaid:questions:case-data:dateOfBirth': 'Geboortedatum',
  'foodaid:questions:case-data:weightKg': 'Gewicht',
  'foodaid:questions:case-data:weightGoal': 'Gewichtsdoel',
  'foodaid:questions:case-data:illnesses': 'Ziekten',
  'foodaid:questions:case-data:foodTypePreferences': 'Voersoort',
  'foodaid:questions:case-data:ownerEmail': 'E-mail',
  'foodaid:questions:case-data:gender': 'Geslacht',
  'foodaid:questions:case-data:neutered': 'Gecastreerd',

  'foodaid:nutritional-plan:header:title': 'Helemaal naar jullie smaak',
  'foodaid:nutritional-plan:header:sub-title':
    'Jullie hebben speciale behoeften - wij hebben het passende voer. Laten we samen het perfecte menu voor {petName} samenstellen.',
  'foodaid:nutritional-plan:header:pet-name': '{petName} heeft nodig',
  'foodaid:nutritional-plan:header:kcalsperday': '{kcalsPerDay} kcal/dag',
  'foodaid:nutritional-plan:header:icon-title-1': 'Passend voor {petName}',
  'foodaid:nutritional-plan:header:icon-title-2': ' Verse ingrediënten voor de beste smaak',
  'foodaid:nutritional-plan:header:icon-title-3': 'Zonder granen & suiker',
  'foodaid:nutritional-plan:product-description':
    'Productinformatie, ingrediënten, vitaminen, hoeveelheden & sporenelementen en voedingsadviezen <a>weergeven</a>',
  'foodaid:nutritional-plan:added-to-cart': 'In de winkelwagen',
  'foodaid:nutritional-plan:in-cart': 'In de winkelwagen',
  'foodaid:nutritional-plan:remove-product': 'Verwijderen',
};
